import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "ml-64 p-8"
}
const _hoisted_2 = {
  id: "page-header",
  class: "mb-8"
}
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_5 = { class: "space-y-2 mb-6" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "space-y-2 mb-6" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "space-y-2 mb-6" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "flex justify-end space-x-2 mt-5" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_14 = { class: "space-y-2 mb-6" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "space-y-2 mb-6" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = { class: "space-y-2 mb-6" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "space-y-2 mb-6" }
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = { class: "flex justify-end space-x-2 mt-5" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  id: "organizations-table",
  class: "bg-white rounded-lg shadow-sm border border-gray-200"
}
const _hoisted_25 = {
  key: 0,
  class: "flex justify-center items-center h-48"
}
const _hoisted_26 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_27 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_28 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }
const _hoisted_30 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_31 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_32 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_34 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium" }
const _hoisted_35 = { class: "flex space-x-3" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 2,
  class: "px-6 py-4 border-t border-gray-200"
}
const _hoisted_40 = { class: "flex items-center justify-between" }
const _hoisted_41 = { class: "text-sm text-gray-700" }
const _hoisted_42 = { class: "font-medium" }
const _hoisted_43 = { class: "font-medium" }
const _hoisted_44 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_45 = { class: "px-3 py-1 bg-blue-600 text-white rounded text-sm" }

import { onMounted, ref, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useOrganizationStore } from '@/store/organizations';
import { useNotificationStore } from '@/store/notifications';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import { useAuthStore } from '@/store/auth';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';
import Modal from '../components/modal.vue';

interface Organization {
  id: string;
  name: string;
  status: string;
  contactName: string;
  contactEmail: string;
  createdAt: string;
  updatedAt: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'organizations',
  setup(__props) {

const organizationStore = useOrganizationStore();
const notificationStore = useNotificationStore();
const authStore = useAuthStore();
const router = useRouter();

const showCreateModal = ref<boolean>(false);
const showEditModal = ref<boolean>(false);
const currentPage = ref<number>(1);
const editingOrg = ref<Organization | null>(null);
const loading = ref<boolean>(false);

const formData = ref({
  name: '',
  contactName: '',
  contactEmail: '',
  status: 'active',
});

const canManageOrganizations = computed(() => {
  const purpose = localStorage.getItem('purpose');
  if (purpose !== 'local') return false;

  const permissions = localStorage.getItem('permissions');
  if (!permissions) return false;
  const permissionList = permissions.split(',').map((p) => p.trim().toLowerCase());
  return permissionList.includes('manage_organizations');
});

onMounted(() => {
  organizationStore.fetchOrganizations(currentPage.value);
});

watch(currentPage, (newPage) => {
  organizationStore.fetchOrganizations(newPage);
});

function formatDate(input: string) {
  const date = new Date(input);
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
  return formatted;
}

function viewOrganization(id: string) {
  router.push({ name: 'organization-detail', params: { id } });
}

function editOrganization(org: Organization) {
  editingOrg.value = org;
  formData.value = {
    name: org.name,
    contactName: org.contactName,
    contactEmail: org.contactEmail,
    status: org.status,
  };
  showEditModal.value = true;
}

async function disableOrganization(id: string) {
  if (!confirm('Are you sure you want to disable this organization?')) return;

  loading.value = true;
  try {
    await organizationStore.disableOrganization(id);

    if (organizationStore.error) {
      notificationStore.showError('Disable Failed', organizationStore.error);
    } else {
      notificationStore.showSuccess('Organization Disabled', 'The organization has been disabled successfully.');
      organizationStore.fetchOrganizations(currentPage.value);
    }
  } catch (err) {
    notificationStore.showError('Disable Error', 'An unexpected error occurred while disabling the organization.');
  } finally {
    loading.value = false;
  }
}

async function handleSubmit() {
  if (!formData.value.name || !formData.value.contactName || !formData.value.contactEmail) {
    notificationStore.showError('Validation Error', 'Please fill in all required fields.');
    return;
  }

  loading.value = true;
  try {
    let success = false;

    if (showCreateModal.value) {
      success = await organizationStore.createOrganization(
        formData.value.name,
        formData.value.contactName,
        formData.value.contactEmail,
      );

      if (organizationStore.error) {
        notificationStore.showError('Create Failed', organizationStore.error);
      } else {
        notificationStore.showSuccess('Organization Created', 'New organization has been created successfully.');
        closeModal();
        organizationStore.fetchOrganizations(currentPage.value);
      }
    } else if (showEditModal.value && editingOrg.value) {
      success = await organizationStore.updateOrganization(
        editingOrg.value.id,
        formData.value.name,
        formData.value.contactName,
        formData.value.contactEmail,
        formData.value.status,
      );

      if (organizationStore.error) {
        notificationStore.showError('Update Failed', organizationStore.error);
      } else {
        notificationStore.showSuccess('Organization Updated', 'Organization has been updated successfully.');
        closeModal();
        organizationStore.fetchOrganizations(currentPage.value);
      }
    }
  } catch (err) {
    notificationStore.showError('Error', 'An unexpected error occurred.');
  } finally {
    loading.value = false;
  }
}

function closeModal() {
  showCreateModal.value = false;
  showEditModal.value = false;
  editingOrg.value = null;
  formData.value = {
    name: '',
    contactName: '',
    contactEmail: '',
    status: 'active',
  };
  organizationStore.clearMessages();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-2xl font-bold text-green-800" }, "Organization Management"),
            _createElementVNode("p", { class: "mt-2 text-gray-600 text-sm" }, "Manage all organizations in the system")
          ], -1)),
          (_unref(authStore).hasPermissions('manage_organizations', 'local'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                id: "create-org-btn",
                class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateModal.value = true))
              }, _cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "fa-solid fa-building mr-1" }, null, -1),
                _createElementVNode("span", null, "Create Organization", -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(Modal, {
        show: showCreateModal.value,
        title: "Create Organization",
        size: "max-w-4xl",
        onClose: _cache[4] || (_cache[4] = ($event: any) => (showCreateModal.value = false))
      }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[11] || (_cache[11] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
              ])))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                class: "space-y-6",
                onSubmit: _withModifiers(handleSubmit, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Organization Name", -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 mb-5 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-building text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event)),
                      type: "text",
                      required: "",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      placeholder: "Organization Name"
                    }, null, 512), [
                      [_vModelText, formData.value.name]
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "The legal name of the organization", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Contact Name", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 mb-5 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-user text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.contactName) = $event)),
                      type: "text",
                      required: "",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      placeholder: "John Doe"
                    }, null, 512), [
                      [_vModelText, formData.value.contactName]
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "Primary contact person for the organization", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Contact Email", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 mb-5 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-envelope text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.contactEmail) = $event)),
                      type: "email",
                      required: "",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      placeholder: "contact@example.com"
                    }, null, 512), [
                      [_vModelText, formData.value.contactEmail]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "Email address for organization communications", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeModal,
                    class: "px-4 py-1 bg-gray-300 rounded-sm hover:bg-gray-400"
                  }, " Cancel "),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _unref(organizationStore).loading,
                    class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50"
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fa-solid fa-save mr-2" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(organizationStore).loading ? 'Processing...' : 'Create Organization'), 1)
                  ], 8, _hoisted_12)
                ])
              ], 32))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(Modal, {
        show: showEditModal.value,
        title: "Edit Organization",
        size: "max-w-4xl",
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(LottieAnimation, {
                  path: "assets/images/loading.json",
                  width: 150,
                  height: 150
                })
              ]))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                class: "space-y-6",
                onSubmit: _withModifiers(handleSubmit, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Organization Name", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 mb-5 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-building text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.name) = $event)),
                      type: "text",
                      required: "",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      placeholder: "Organization Name"
                    }, null, 512), [
                      [_vModelText, formData.value.name]
                    ]),
                    _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "The legal name of the organization", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Contact Name", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 mb-5 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-user text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.contactName) = $event)),
                      type: "text",
                      required: "",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      placeholder: "John Doe"
                    }, null, 512), [
                      [_vModelText, formData.value.contactName]
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "Primary contact person for the organization", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Contact Email", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 mb-5 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-envelope text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.contactEmail) = $event)),
                      type: "email",
                      required: "",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      placeholder: "contact@example.com"
                    }, null, 512), [
                      [_vModelText, formData.value.contactEmail]
                    ]),
                    _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "Email address for organization communications", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Status", -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 mb-5 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-toggle-on text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.status) = $event)),
                      required: "",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    }, _cache[31] || (_cache[31] = [
                      _createElementVNode("option", { value: "ACTIVE" }, "Active", -1),
                      _createElementVNode("option", { value: "INACTIVE" }, "Inactive", -1),
                      _createElementVNode("option", { value: "DISABLED" }, "Disabled", -1)
                    ]), 512), [
                      [_vModelSelect, formData.value.status]
                    ]),
                    _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "Current status of the organization", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeModal,
                    class: "px-4 py-1 bg-gray-300 rounded-sm hover:bg-gray-400"
                  }, " Cancel "),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _unref(organizationStore).loading,
                    class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50"
                  }, [
                    _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fa-solid fa-save mr-2" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(organizationStore).loading ? 'Processing...' : 'Update Organization'), 1)
                  ], 8, _hoisted_23)
                ])
              ], 32))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("div", _hoisted_24, [
        (_unref(organizationStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[36] || (_cache[36] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("table", _hoisted_27, [
                _cache[40] || (_cache[40] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Name "),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Contact Person "),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Contact Email "),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Status "),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Created "),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Actions ")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizationStore).organizationResults, (org) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: org.id
                    }, [
                      _createElementVNode("td", _hoisted_29, _toDisplayString(org.name), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(org.contactName), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(org.contactEmail), 1),
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("span", {
                          class: _normalizeClass({
                  'px-2 inline-flex text-xs leading-5 font-semibold rounded-full': true,
                  'bg-green-100 text-green-800': org.status === 'Active',
                  'bg-yellow-100 text-yellow-800': org.status === 'Inactive',
                  'bg-red-100 text-red-800': org.status === 'Disabled'
                })
                        }, _toDisplayString(org.status), 3)
                      ]),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(formatDate(org.createdAt)), 1),
                      _createElementVNode("td", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (viewOrganization(org.id)),
                            class: "text-green-600 hover:text-green-900",
                            title: "View Organization"
                          }, _cache[37] || (_cache[37] = [
                            _createElementVNode("i", { class: "fa-solid fa-eye" }, null, -1)
                          ]), 8, _hoisted_36),
                          (canManageOrganizations.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (editOrganization(org)),
                                  class: "text-indigo-600 hover:text-indigo-900",
                                  title: "Edit Organization"
                                }, _cache[38] || (_cache[38] = [
                                  _createElementVNode("i", { class: "fa-solid fa-edit" }, null, -1)
                                ]), 8, _hoisted_37),
                                (org.status !== 'disabled')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => (disableOrganization(org.id)),
                                      class: "text-red-600 hover:text-red-900",
                                      title: "Disable Organization"
                                    }, _cache[39] || (_cache[39] = [
                                      _createElementVNode("i", { class: "fa-solid fa-ban" }, null, -1)
                                    ]), 8, _hoisted_38))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])),
        (_unref(organizationStore).pagination.totalPages && _unref(organizationStore).pagination.totalPages > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _cache[41] || (_cache[41] = _createTextVNode(" Showing ", -1)),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(organizationStore).pagination.currentPage), 1),
                  _cache[42] || (_cache[42] = _createTextVNode(" of ", -1)),
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(organizationStore).pagination.totalPages), 1),
                  _cache[43] || (_cache[43] = _createTextVNode(" results ", -1))
                ]),
                (_unref(organizationStore).pagination.nextPage > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _cache[44] || (_cache[44] = _createElementVNode("button", {
                        class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-500 hover:bg-gray-50",
                        disabled: ""
                      }, "Previous", -1)),
                      _createElementVNode("button", _hoisted_45, _toDisplayString(_unref(organizationStore).pagination.nextPage), 1),
                      _cache[45] || (_cache[45] = _createElementVNode("button", { class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" }, "Next", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})